// This component is a placeholder and will be replaced by a full implementation
export default function CoursePlayer() {
  return <div>Course Player Page</div>;
}
